import React from 'react';
import './inputs.scss';

export const StyledInput = React.forwardRef(({ disabled, className = '', ...props }, ref) => {
  const combinedClassName = `caazam-input ${className}`.trim();

  return (
        <input
              {...props}
              disabled={disabled}
              className={combinedClassName}
              ref={ref}
        />
  );
});
